export const THEME_COLORS = [
  "#018752",
  "#0079C2",
  "#515151",
  "#930000",
  "#D97706",
  "#6D28D9",
  "#0F172A",
  "#10B981",
  "#2563EB",
  "#DC2626",
  "#F59E0B",
  "#7C3AED",
];

export const STORE_TIME_ZONES = [
  { label: "Eastern Time (US & Canada)", iana: "America/New_York" },
  { label: "Central Time (US & Canada)", iana: "America/Chicago" },
  { label: "Mountain Time (US & Canada)", iana: "America/Denver" },
  { label: "Arizona (no DST)", iana: "America/Phoenix" },
  { label: "Pacific Time (US & Canada)", iana: "America/Los_Angeles" },
  { label: "Alaska Time", iana: "America/Anchorage" },
  { label: "Hawaii Time", iana: "Pacific/Honolulu" },
  { label: "Atlantic Time (Canada)", iana: "America/Halifax" },
  { label: "Newfoundland Time", iana: "America/St_Johns" },
  { label: "Toronto (ET)", iana: "America/Toronto" },
  { label: "Vancouver (PT)", iana: "America/Vancouver" },
  { label: "Mexico City (CST/CDT)", iana: "America/Mexico_City" },
  { label: "Bogotá / Lima (COT/PET)", iana: "America/Bogota" },
  { label: "São Paulo (BRT)", iana: "America/Sao_Paulo" },
  { label: "London (GMT/BST)", iana: "Europe/London" },
  { label: "Paris / Berlin (CET/CEST)", iana: "Europe/Paris" },
  { label: "Dubai (GST)", iana: "Asia/Dubai" },
  { label: "Colombo / Kolkata (IST)", iana: "Asia/Colombo" },
  { label: "Singapore / HK (SGT/HKT)", iana: "Asia/Singapore" },
  { label: "Tokyo (JST)", iana: "Asia/Tokyo" },
  { label: "Sydney (AEST/AEDT)", iana: "Australia/Sydney" },
  { label: "UTC", iana: "UTC" },
];

// Saved as the postal code, which is what receipts print
export const US_STATES = [
  ["AL", "Alabama"], ["AK", "Alaska"], ["AZ", "Arizona"], ["AR", "Arkansas"], ["CA", "California"],
  ["CO", "Colorado"], ["CT", "Connecticut"], ["DE", "Delaware"], ["DC", "District of Columbia"],
  ["FL", "Florida"], ["GA", "Georgia"], ["HI", "Hawaii"], ["ID", "Idaho"], ["IL", "Illinois"],
  ["IN", "Indiana"], ["IA", "Iowa"], ["KS", "Kansas"], ["KY", "Kentucky"], ["LA", "Louisiana"],
  ["ME", "Maine"], ["MD", "Maryland"], ["MA", "Massachusetts"], ["MI", "Michigan"], ["MN", "Minnesota"],
  ["MS", "Mississippi"], ["MO", "Missouri"], ["MT", "Montana"], ["NE", "Nebraska"], ["NV", "Nevada"],
  ["NH", "New Hampshire"], ["NJ", "New Jersey"], ["NM", "New Mexico"], ["NY", "New York"],
  ["NC", "North Carolina"], ["ND", "North Dakota"], ["OH", "Ohio"], ["OK", "Oklahoma"], ["OR", "Oregon"],
  ["PA", "Pennsylvania"], ["RI", "Rhode Island"], ["SC", "South Carolina"], ["SD", "South Dakota"],
  ["TN", "Tennessee"], ["TX", "Texas"], ["UT", "Utah"], ["VT", "Vermont"], ["VA", "Virginia"],
  ["WA", "Washington"], ["WV", "West Virginia"], ["WI", "Wisconsin"], ["WY", "Wyoming"],
].map(([code, name]) => ({ code, name }));
